/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sellers_Stats_Freegames1Inputs */

const id_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Gratis`)
};

const ms_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Percuma`)
};

const da_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Spil`)
};

const de_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Spiele`)
};

const en_us2_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Games`)
};

const es_es2_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis`)
};

const es_mx2_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis`)
};

const fil_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Libreng Laro`)
};

const fr_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux gratuits`)
};

const it_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi gratuiti`)
};

const hu_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes játékok`)
};

const nl_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis games`)
};

const no_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spill`)
};

const pl_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe gry`)
};

const pt_br2_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos Grátis`)
};

const pt_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis`)
};

const ro_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri gratuite`)
};

const fi_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaispelit`)
};

const sv_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spel`)
};

const vi_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game miễn phí`)
};

const tr_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz Oyunlar`)
};

const cs_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hry zdarma`)
};

const bg_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатни игри`)
};

const ru_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатных игр`)
};

const uk_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовних ігор`)
};

const ar_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب المجانية`)
};

const hi_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त गेम`)
};

const th_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมฟรี`)
};

const ja_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ゲーム`)
};

const zh_cn2_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费游戏`)
};

const zh_hant1_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費遊戲`)
};

const ko_sellers_stats_freegames1 = /** @type {(inputs: Sellers_Stats_Freegames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 게임`)
};

/**
* | output |
* | --- |
* | "Free Games" |
*
* @param {Sellers_Stats_Freegames1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sellers_stats_freegames1 = /** @type {((inputs?: Sellers_Stats_Freegames1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sellers_Stats_Freegames1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sellers_stats_freegames1(inputs)
	if (locale === "ms") return ms_sellers_stats_freegames1(inputs)
	if (locale === "da") return da_sellers_stats_freegames1(inputs)
	if (locale === "de") return de_sellers_stats_freegames1(inputs)
	if (locale === "en-US") return en_us2_sellers_stats_freegames1(inputs)
	if (locale === "es-ES") return es_es2_sellers_stats_freegames1(inputs)
	if (locale === "es-MX") return es_mx2_sellers_stats_freegames1(inputs)
	if (locale === "fil") return fil_sellers_stats_freegames1(inputs)
	if (locale === "fr") return fr_sellers_stats_freegames1(inputs)
	if (locale === "it") return it_sellers_stats_freegames1(inputs)
	if (locale === "hu") return hu_sellers_stats_freegames1(inputs)
	if (locale === "nl") return nl_sellers_stats_freegames1(inputs)
	if (locale === "no") return no_sellers_stats_freegames1(inputs)
	if (locale === "pl") return pl_sellers_stats_freegames1(inputs)
	if (locale === "pt-BR") return pt_br2_sellers_stats_freegames1(inputs)
	if (locale === "pt") return pt_sellers_stats_freegames1(inputs)
	if (locale === "ro") return ro_sellers_stats_freegames1(inputs)
	if (locale === "fi") return fi_sellers_stats_freegames1(inputs)
	if (locale === "sv") return sv_sellers_stats_freegames1(inputs)
	if (locale === "vi") return vi_sellers_stats_freegames1(inputs)
	if (locale === "tr") return tr_sellers_stats_freegames1(inputs)
	if (locale === "cs") return cs_sellers_stats_freegames1(inputs)
	if (locale === "bg") return bg_sellers_stats_freegames1(inputs)
	if (locale === "ru") return ru_sellers_stats_freegames1(inputs)
	if (locale === "uk") return uk_sellers_stats_freegames1(inputs)
	if (locale === "ar") return ar_sellers_stats_freegames1(inputs)
	if (locale === "hi") return hi_sellers_stats_freegames1(inputs)
	if (locale === "th") return th_sellers_stats_freegames1(inputs)
	if (locale === "ja") return ja_sellers_stats_freegames1(inputs)
	if (locale === "zh-CN") return zh_cn2_sellers_stats_freegames1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sellers_stats_freegames1(inputs)
	return ko_sellers_stats_freegames1(inputs)
});
export { sellers_stats_freegames1 as "sellers.stats.freeGames" }